import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";

// Camera insignia marker (blue camera icon)
const CAM_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" style="filter: drop-shadow(0 1px 2px rgba(0,0,0,0.6));">
  <path d="M9 6.5l1.4-2.5h3.2L15 6.5" fill="#457B9D" stroke="#0A0D0C" stroke-width="1.4" stroke-linejoin="round"/>
  <rect x="2.2" y="6.5" width="19.6" height="13.5" rx="2.5" fill="#457B9D" stroke="#0A0D0C" stroke-width="1.4"/>
  <circle cx="12" cy="13.2" r="4.2" fill="#0A0D0C"/>
  <circle cx="12" cy="13.2" r="2.3" fill="#A8DADC"/>
  <circle cx="18.6" cy="9.3" r="0.9" fill="#A8DADC"/>
</svg>`;

const CAM_ICON = L.divIcon({
  className: "",
  html: CAM_SVG,
  iconSize: [15, 15],
  iconAnchor: [7.5, 7.5],
  popupAnchor: [0, -7],
});

export default function CameraLayer({ cameras, onOpenCamera }) {
  return cameras.map((cam) => (
    <Marker key={`cam-${cam.id}`} position={[cam.lat, cam.lon]} icon={CAM_ICON}>
      <Popup>
        <div className="min-w-[200px]">
          <div className="text-[10px] font-bold uppercase tracking-wider text-tac-info mb-1">
            Wildfire Camera
          </div>
          <div className="font-display font-bold text-sm text-tac-text mb-1">{cam.name}</div>
          <div className="text-[14px] text-tac-dim mb-1">{cam.operator}</div>
          <button
            type="button"
            onClick={() => onOpenCamera(cam)}
            data-testid={`map-cam-open-${cam.id}`}
            className="text-[11px] font-bold uppercase tracking-wider text-tac-primary hover:underline"
          >
            Open Camera →
          </button>
        </div>
      </Popup>
    </Marker>
  ));
}
